import SiafLiteApiRepository from "../../external/siafLiteApi";

class GruposTributarioService {
  constructor() {
    this.urlBase = "/fiscal/grupos-tributario";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  findOrCreateGruposTributarios(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/find-create-grupos-tributarios`,
    ).patch(body);
  }
}

export default GruposTributarioService;
